export default "__VITE_ASSET__CSXpAX3q__"